export const ZIP_FILE_TYPES: FileMimeType[] = ['application/zip', 'application/x-zip-compressed'];

export const IMAGE_FILE_TYPES: FileMimeType[] = ['image/png', 'image/jpeg', 'image/webp'];

// Unfortunately, if we don't accept all files, the file upload input will not accept the .srt/.vtt files;
export const CLOSED_CAPTION_FILE_TYPES: FileMimeType[] = ['*'];

export type FileMimeType = '*' | `${string}/${string}`;
